import { render, staticRenderFns } from "./View.vue?vue&type=template&id=a6e8d0e6&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=a6e8d0e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e8d0e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6e8d0e6')) {
      api.createRecord('a6e8d0e6', component.options)
    } else {
      api.reload('a6e8d0e6', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=a6e8d0e6&scoped=true", function () {
      api.rerender('a6e8d0e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/Balloon/View.vue"
export default component.exports